import { uniq } from 'ramda';

import { formatDate, documentType } from './commonMapper';
import evolve from './evolve';

export const companyMapper = evolve({
    documents: data => documentType(evolve({ date: formatDate })(data)),
    contacts: data => uniq(data.split(/\n/))
});
